/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/account-profile';

const styles = {
  textBody: () => css`
    margin-bottom: var(--cds-spacing-300);
  `,
};

type PropsFromCaller = {
  isOpen: boolean;
  onClose: () => void;
};

type PropsToComponent = PropsFromCaller;

export const CredentialsInfoDialog = ({ isOpen, onClose }: PropsToComponent) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <Dialog.HeadingGroup>{_t('Credentials')}</Dialog.HeadingGroup>
      <Dialog.Content>
        <TrackedDiv
          trackClicks={false}
          requireFullyVisible={false}
          withVisibilityTracking
          // not tracked in eventing v3
          trackingName="profile_education_history_info_dialog"
        >
          <Typography2 variant="bodyPrimary" component="p" css={styles.textBody}>
            {_t(
              'These provide a record of education experience, including any Specializations or Professional Certificates completed on Coursera.'
            )}
          </Typography2>
          <Typography2 component="h3" variant="subtitleMedium">
            {_t('Professional Certificates')}
          </Typography2>
          <Typography2 variant="bodyPrimary" component="p" css={styles.textBody}>
            {_t(
              'Career-focused credentials from industry leaders that demonstrate candidates’ expertise and job readiness.'
            )}
          </Typography2>
          <Typography2 component="h3" variant="subtitleMedium">
            {_t('Specializations')}
          </Typography2>
          <Typography2 variant="bodyPrimary" component="p">
            {_t('A series of courses and projects that provides candidates with in-depth knowledge of a subject.')}
          </Typography2>
        </TrackedDiv>
      </Dialog.Content>
      <Dialog.Actions>
        <Button variant="primary" onClick={onClose}>
          {_t('Got it')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default CredentialsInfoDialog;
